'use client';

import { useCallback } from 'react';

import {
  getPartnerProceduresFromSearchApi,
  mergePartnerProcedureGroups,
  PartnerProcedureGroup,
} from '@/app/(main)/(pages)/(institucional)/(index)/parceiros/_services/get-partner-procedures-from-search-api.service';
import {
  EntityProceduresChannelState,
  useEntityProcedures,
  UseEntityProceduresReturn,
} from '@/app/(main)/(pages)/_components/entities/entity-procedure/_hooks/use-entity-procedures.hook';
import { SearchApiServiceChannel } from '@/app/(main)/(pages)/_types/search-api-response.type';

export type PartnerProceduresChannelState = EntityProceduresChannelState<PartnerProcedureGroup>;
export type UsePartnerProceduresReturn = UseEntityProceduresReturn<PartnerProcedureGroup>;

export interface UsePartnerProceduresOptions {
  enabled?: boolean;
}

export function usePartnerProcedures(
  partnerId: string,
  { enabled = true }: UsePartnerProceduresOptions = {},
): UsePartnerProceduresReturn {
  const fetchPage = useCallback(
    ({ serviceChannel, page }: { serviceChannel: SearchApiServiceChannel; page: number }) =>
      getPartnerProceduresFromSearchApi({ partnerId, serviceChannel, page }),
    [partnerId],
  );

  return useEntityProcedures({ fetchPage, mergeGroups: mergePartnerProcedureGroups, enabled });
}
